import { render, staticRenderFns } from "./LogoLayout.vue?vue&type=template&id=34fca3b6&scoped=true"
import script from "./LogoLayout.vue?vue&type=script&lang=js"
export * from "./LogoLayout.vue?vue&type=script&lang=js"
import style0 from "./LogoLayout.vue?vue&type=style&index=0&id=34fca3b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fca3b6",
  null
  
)

export default component.exports